export default __webpack_public_path__ + "static/ASLA_Linia_2-793407fba06965321ad03245098ce9fd.png";